import React, { useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { addFeedback, addFeedbackComments } from '../../API/RDPMS_API';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

const AlertFeedbackCommentModal = ({ role, feedbackId, onHide }) => {
    const { t } = useTranslation();
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));

    const schema = yup.object().shape({
        descriptions: yup.string().required(t('Please enter comment')),
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    const onSubmit = async (formData) => {
        let request = {
            role,
            feedbackId,
            descriptions: formData.descriptions,
        };

        let response = await addFeedbackComments(request);

        if (response) {
            toast.success('Added comment sucessfully', {
                position: toast.POSITION.TOP_RIGHT,
            });
            onHide();
        } else {
            toast.error('Please try again', {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    return (
        <>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="mb-3">
                    <Form.Label>{t('Comment')}</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={6}
                        {...register('descriptions')}
                        isInvalid={!!errors.descriptions}
                    />
                    {errors.descriptions && (
                        <Form.Control.Feedback type="invalid">{errors.descriptions.message}</Form.Control.Feedback>
                    )}
                </Form.Group>
                <div className="text-end">
                    <Button type="submit" className="btn btn-success mt-2">
                        <i className="mdi mdi-content-save"></i> {t('Send Comments')}
                    </Button>
                </div>
            </Form>
        </>
    );
};

export default AlertFeedbackCommentModal;
